<template>
  <chat-window
    :messages="messages"
    :requestUrl="requestUrl"
    :requestParams="requestParams"
    :focus="focus"
    :saveOnDestroy="true"
    errorName="note"
    placeholder="Write note"
  />
</template>

<script>
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
import ChatWindow from "vue-components/chat-window/chat-window";

const { mapState, mapMutations } = createNamespacedHelpers("activityNotes");

export default {
  components: {
    ChatWindow,
  },
  props: {
    focus: { type: Boolean },
  },
  computed: {
    ...mapState(["activity"]),
    requestUrl() {
      return `${this.$_activityNotes_config.jiminnyHost()}/api/v1/activity/${
        this.activity.id
      }/note`;
    },
    messages() {
      return this.activity.notes.map((note) => {
        return {
          id: note.id,
          message: note.note,
          time: note.timeForHumans,
          user: {
            name: note.user.name,
            photoUrl: note.user.photoUrl,
          },
          align: "left",
        };
      });
    },
  },
  created() {
    this.handlePusherEvents();
  },
  beforeDestroy() {
    this.$pusher.unsubscribe(this.$_pusherPrivateChannelName);
  },
  methods: {
    ...mapMutations(["addNote"]),
    handlePusherEvents() {
      this.$_pusherPrivateChannelName = `private-activity.${this.activity.id}`;
      const channel = this.$pusher.subscribe(this.$_pusherPrivateChannelName);
      channel.bind("activity.note-taken", this.addNote);
    },
    requestParams(message) {
      let elapsedSeconds;

      if (this.activity.actualEndTime) {
        const start = moment.utc(this.activity.actualStartTime);
        const end = moment.utc(this.activity.actualEndTime);
        elapsedSeconds = end.diff(start) / 1000;
      } else if (this.activity.actualStartTime) {
        const start = moment.utc(this.activity.actualStartTime);
        elapsedSeconds = moment.utc().diff(start) / 1000;
      } else {
        elapsedSeconds = 0;
      }

      return {
        note: message,
        time: elapsedSeconds,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// activity-notes.vue?92cf6378